const mediaItems = [
  {
    title: '《繁花》· 王家卫首部电视剧',
    desc: '沪上风云，时代群像。金宇澄原著改编，王家卫十年磨一剑，讲述90年代上海滩商海沉浮与人间百态。',
    tags: ['剧情', '时代', '热播'],
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Shanghai%20cityscape%20with%20warm%20golden%20neon%20lights%2C%201990s%20nostalgic%20atmosphere%2C%20elegant%20Chinese%20drama%20aesthetic%2C%20film%20noir%20lighting%20with%20amber%20tones%2C%20sophisticated%20urban%20scene%2C%20no%20text&width=800&height=450&seq=media-01-2026&orientation=landscape',
    duration: '全30集',
  },
  {
    title: '《流浪地球3》· 科幻史诗终章',
    desc: '人类命运何去何从？郭帆导演科幻系列收官之作，超越想象的视觉奇观与深刻的文明思辨。',
    tags: ['科幻', '冒险', '新上线'],
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20earth%20and%20stars%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20blockbuster%20aesthetic%2C%20warm%20orange%20and%20deep%20space%20contrast%2C%20atmospheric%20planetary%20view%2C%20no%20text&width=800&height=450&seq=media-02-2026&orientation=landscape',
    duration: '2h 36min',
  },
  {
    title: '《狂飙》· 年度现象级刑侦剧',
    desc: '扫黑除恶，正邪较量。张译张颂文同台飙戏，二十年跨度展现基层干警与黑恶势力的殊死对抗。',
    tags: ['刑侦', '悬疑', '经典'],
    img: 'https://readdy.ai/api/search-image?query=Moody%20urban%20night%20street%20scene%20with%20dramatic%20lighting%2C%20crime%20drama%20cinematography%20style%2C%20warm%20street%20lamps%20and%20deep%20shadows%2C%20intense%20atmospheric%20tension%2C%20Chinese%20city%20noir%2C%20no%20text&width=800&height=450&seq=media-03-2026&orientation=landscape',
    duration: '全39集',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热播精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">每日精选高分影视，告别剧荒。从经典到新片，你想看的这里都有。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 text-xs font-medium rounded-full bg-white/20 backdrop-blur-sm text-white whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 text-xs font-medium rounded-md bg-background-950/70 text-white whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}